<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->
<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase showcase-title="Endorsement Management">
  <div class="showcase-body">
    <div class="margin: auto; max-width: 1000px; margin-bottom: 50px;margin-top: 20px;">
      <span class="section-header">Add New</span>
      <div class="row">
        <div class="col-lg-4 col-md-8 col-sm-8 col-xs-8 group">
          <input id="newName" #newName class="modelo-text-input" type="text" (blur)="onBlur($event)">
          <label for="newName">Name:</label>
        </div>
        <div class="col-lg-2 col-md-4 col-sml-4 col-xs-4 group">
          <input id="newDesc" #newDesc class="modelo-text-input" type="text" (blur)="onBlur($event)">
          <label for="newDesc">Description:</label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group">
          <button id="addNew" class="btn-xs btn-primary btn-group" (click)="addNew(newName.value, newDesc.value)"><i
            class="fa fa-save"></i>&nbsp;Submit
          </button>
        </div>
      </div>
      <div>&nbsp;</div>
      <table class="bordered-table highlight-table ">
        <thead class="data-table-header">
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Active</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let endorsement of _endorsements; let i = index" class="data-table-row">
          <td>
            <input class="modelo-text-input" type="text" [(ngModel)]="endorsement.endorsementName" (change)="updateIndexes(i)">
          </td>
          <td>
            <input class="modelo-text-input" type="text" [(ngModel)]="endorsement.endorsementDesc" (change)="updateIndexes(i)">
          </td>
          <td>
            <select id="isActive" name="isActive" [(ngModel)]="endorsement.active" (change)="updateIndexes(i)">
              <option [value]="true" [selected]="endorsement.active == true">true</option>
              <option [value]="false" [selected]="endorsement.active == false">false</option>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" (click)="saveChanges()"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange class="btn btn-primary-white btn-group" onclick="window.location.reload()">
    <i class="fa fa-refresh"></i>&nbsp;Reset</button>&nbsp;
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>
